import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    width: 300,
    height: 35,
    border: `1px solid ${theme.palette.custom.grey}`,
    borderRadius: 20,
    margin: 10,
    paddingLeft: 20,
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  },

  input: {
    marginLeft: 5,
    backgroundColor: theme.palette.custom.white,
    fontWeight: 700,
    fontSize: 12,
    width: '100%',
    border: 'none',
    '&:focus': {
      outline: 'none',
    },
    '&::placeholder': {
      color: theme.palette.custom.grey2,
    },
    '&:not(:placeholder-shown)': {
      color: 'black',
    },
  },
}))

export default useStyles
